// Cómo se nombra al cliente de una venta en tablas, fichas y tickets.

export const SALE_WITHOUT_CUSTOMER_LABEL = 'Venta sin cliente';

/** El nombre del snapshot; sin cliente ligado, «Venta sin cliente»; `null` si falta el nombre. */
export function saleCustomerLabel(sale: {
    retailCustomerId: string | null;
    customerName: string | null;
}): string | null {
    const name = sale.customerName?.trim();
    if (name) return name;
    return sale.retailCustomerId ? null : SALE_WITHOUT_CUSTOMER_LABEL;
}
